import { render, staticRenderFns } from "./NonGradingSystem.vue?vue&type=template&id=6b51ab4a&"
import script from "./NonGradingSystem.vue?vue&type=script&lang=js&"
export * from "./NonGradingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports